<template>
  <div class="x_panel">
    <div class="x_content comments-wrapper">
      <ul
        v-if="item.comments && item.comments.length > 0"
        class="list-unstyled comments">
        <li
          v-for="comment in commentsSorted"
          :key="comment.id">
          <div
            :class="isSelf(comment.commentedBy.email) ? 'is-self-message' : ''"
            class="comments-item">
            <span class="image">
              <img
                :src="comment.commentedBy.thumb"
                alt="img">
            </span>
            <div class="speech-bubble--wrapper">
              <div class="speech-bubble">
                <span class="message">
                  {{ comment.text }}
                </span>
              </div>
              <p class="user-title-comment">
                <small>
                  {{ comment.commentedBy.firstName }}
                  <span class="time">{{ comment.created | moment("from", "now") }}</span>
                </small>
              </p>
            </div>
          </div>
        </li>
      </ul>
      <div
        v-else
        class="well">
        <h3 class="center-block text-center">No messages to display</h3>
        <p class="center-block text-center"><small>Add a message below</small></p>
      </div>
      <el-form
        ref="commentForm"
        :inline="true"
        :rules="commentRules"
        :model="commentForm"
        class="comment-form">
        <el-form-item
          prop="comment"
          class="comment-form--message">
          <at-ta
            v-model="commentForm.comment"
            :members="members"
            name-key="firstName"
            @insert="memberSelectedHandler">
            <template
              slot="item"
              slot-scope="s">
              <img :src="s.item.thumb">
              <span v-html="`${s.item.firstName} ${s.item.lastName}`"></span>
            </template>
            <textarea
              class="editor"
              rows="1"
              placeholder="Type here a message, question, information..."></textarea>
          </at-ta>
        </el-form-item>
        <el-form-item class="comment-form--submit">
          <el-button
            class="pull-right btn-block"
            type="success"
            @click="sendComment('commentForm')">
            Send
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import getAccounts from '@/services/accounts';
import AtTa from '@/vendors/vue-at/dist/vue-at-textarea';
import _ from 'lodash';

export default {
  components: {
    AtTa,
  },
  props: {
    item: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      members: [],
      mentions: [],
      commentForm: {
        comment: '',
      },
      commentRules: {
        comment: [
          { min: 3, message: 'Comment should have at least 3 characters', trigger: 'blur' },
          { max: 500, message: 'Comment should be maximum 500 characters', trigger: 'blur' },
          { required: true, message: 'A message is required', trigger: 'blur' },
        ],
      },
      commentsUpdates: [],
      isDisabled: false,
      isLoading: false,
      comments: [],
    };
  },
  computed: {
    ...mapGetters({
      getUser: 'getUser',
    }),
    commentsSorted() {
      return _.sortBy(this.item.comments, 'id').reverse();
    },
  },
  created() {
    getAccounts().then(response => response.data).then((data) => {
      this.members = data.results;
      return this.members;
    });
  },
  methods: {
    ...mapActions({
      setRTComment: 'setRTComment',
    }),
    memberSelectedHandler(e) {
      return this.mentions.push(e.email);
    },
    isSelf(email) {
      if (this.getUser.email === email) {
        return true;
      }
      return false;
    },
    sendComment(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.setRTComment({ rtId: this.item.id, comment: this.commentForm.comment, mentions: this.mentions });
          this.$refs[formName].resetFields();
          this.mentions = [];
        }
        return false;
      });
    },
  },
};
</script>
<style lang="scss">
  .comments-wrapper {
    max-width: 1020px;
    display: block;
    margin: 30px auto 70px auto;
  position: relative;
}
.comment-form {
  box-shadow: 0px -12px 19px -9px rgba(0,0,0,0.25);
  width: 100%;
  position: fixed;
  z-index: 15;
  bottom: 0;
  right: 0;
  background: #fff;
  display: flex;
  align-items:center;
  justify-content: center;
  transition: .2s ease;
  padding: 20px 40px;
  @media screen and (min-width: 992px) {
    left: 175px;
    width: calc(100% - 175px);
  }
  .el-form-item {
    margin-bottom: 0;
  }
  .comment-form--message {
    width: 100%;
    .el-form-item__content {
      width: 100%;
    }
  }
  .comment-form--submit {
    width: 14%;
    margin-right: 0;
    .el-form-item__content {
      width: 100%;
    }
    .el-button {
      line-height: 2.3;
    }
  }
}
.toggled .comment-form {
  width: 100%;
  left: 0;
}
.atwho-li {
  padding: 20px 12px;
}
.atwho-li img {
  width: 100%;
  display: inline-block;
  max-width: 30px;
  margin-right: 10px;
}
.atwho-view {
  min-width: 250px;
}
textarea.editor {
  width: 100%;
  border-radius: 5px;
  padding: 7px;
}
.atwho-li span {
  text-transform: capitalize;
}
</style>



// WEBPACK FOOTER //
// src/components/receivables/receivable/receivable-details/partials/ReceivableComments.vue